// This code is used to prevent the site to scroll up on load the page
 
window.currentScroll = 0;

["wheel", "touchmove", "keydown", "keyup", "pointerup", "pointerdown"].forEach(evt => {
    window.addEventListener(evt, () => {
    window.currentScroll = window.scrollY;
    }, { passive: true });
});

window.addEventListener("load", () => {
    const saved = window.currentScroll;
    if (saved > 0) {
    // retry a few times until layout is fully settled
    let attempts = 0;
    const restoreScroll = () => {
        window.scrollTo({ top: saved, behavior: "auto" });
        attempts++;
        if (attempts < 10) {
        requestAnimationFrame(restoreScroll);
        }
    };
    requestAnimationFrame(restoreScroll);
    }
}); 

//X This code is used to prevent the site to scroll up on load the page X//

// FAQ scroll added
 
  const FAQ_Section=document?.querySelector("#pajamaFAQSection")?.parentElement;
  const FAQ_Container=FAQ_Section?.querySelector("h2");
  const faqButton = document?.querySelector('#seeFaqs p');
  if(faqButton){
    faqButton.style.textDecoration="underline";
    faqButton.style.cursor="pointer";
    faqButton.addEventListener("click",function(){
      FAQ_Section?.scrollIntoView({ behavior: 'smooth' })
    });
  }
  // const reviewImageSection=document.querySelector(".imageSection").parentElement;
  // reviewImageSection.style.cssText="display:flex;justify-content:center;"
  const reviewImageSection = document.querySelector(".imageSection");

  if (reviewImageSection && reviewImageSection.parentElement) {
    const parentElement = reviewImageSection.parentElement;
    
    if (parentElement instanceof HTMLElement) {
      parentElement.style.cssText = "display:flex;justify-content:center;";
    }
  }